import React from 'react';

export const name = 'building';

export const Building = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    color="#6C717C"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 15.5V21.5H19V15.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M4.92725 4.33647C5.39549 3.22369 6.48514 2.5 7.69243 2.5H16.3076C17.5149 2.5 18.6045 3.22369 19.0727 4.33647L20.7652 8.3586C20.9202 8.72693 21 9.12252 21 9.52213V10.5573C21 11.2512 20.6563 11.9001 20.0822 12.2899V12.2899C19.0321 13.0029 17.6333 12.918 16.6772 12.0833L16.4185 11.8574C15.7062 11.2356 14.6327 11.2769 13.9703 11.9516V11.9516C13.1088 12.829 11.721 12.906 10.7678 12.1293L10.4883 11.9015C9.67922 11.2423 8.50715 11.2839 7.74683 11.9987L7.70549 12.0376C6.78269 12.9052 5.39945 13.0632 4.30477 12.4261L4.15411 12.3384C3.43956 11.9225 3 11.1581 3 10.3313V9.52213C3 9.12252 3.07984 8.72693 3.23482 8.3586L4.92725 4.33647Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <line
      x1="6.75"
      y1="7.25"
      x2="17.25"
      y2="7.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
